import { customApiCall } from "utils/axios";

import { crremUrls } from "./urls";

export const downloadCrremEnergyInputTemplate = (errorMessage?: string) =>
  customApiCall.download({
    errorMessage,
    fileName: "crrem-energy-input-template.xlsx",
    url: crremUrls.energyInputTemplate,
  });

export const uploadCrremEnergyInput = (projectId: string, file: File) =>
  customApiCall.upload({ data: { file }, url: crremUrls.energyInputUpload(projectId) });
